import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { ComponentInterface } from '../component-interface';
var UNDEF,
    MOUSEOVER = 'fc-mouseover',
    MOUSEDOWN = 'fc-mousedown',
    MOUSEUP = 'fc-mouseup',
    MOUSEMOVE = 'fc-mousemove',
    MOUSEOUT = 'fc-mouseout',
    CLICK = 'fc-click';

var MouseTracker =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(MouseTracker, _ComponentInterface);

  function MouseTracker() {
    var _this;

    _classCallCheck(this, MouseTracker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MouseTracker).call(this)), _this.pIndex = 1, _this.handler = function (a) {
      return function (b) {
        b.originalEvent && a.getFromEnv('chart')._mouseEvtHandler(b, a.config.evtData);
      };
    }(_assertThisInitialized(_assertThisInitialized(_this))), _this.eventsList = [MOUSEDOWN, MOUSEUP, MOUSEMOVE, CLICK, MOUSEOVER], _this.config = {}, _this.config.evtData = {};
    return _this;
  }

  _createClass(MouseTracker, [{
    key: "getMouseEvents",
    value: function getMouseEvents(a, b, c) {
      var d = this,
          e = d._lastDatasetIndex,
          f = d._lastPointIndex,
          g = a.type,
          h = {
        fireOut: !1,
        events: []
      };
      return g === CLICK ? h.events.push(CLICK) : g === MOUSEMOVE ? e === b && f === c ? (clearTimeout(d.mouseoutTimer), h.events.push(MOUSEMOVE)) : (h.events.push(MOUSEOVER), h.fireOut = !0) : g === MOUSEDOWN ? ((e !== b || f !== c) && (h.fireOut = !0, h.events.push(MOUSEOVER)), h.events.push(MOUSEDOWN)) : g === MOUSEOVER ? e === b && f === c ? clearTimeout(d.mouseoutTimer) : (h.fireOut = !0, h.events.push(MOUSEOVER)) : g === MOUSEUP ? (d.hasTouchEvent = !1, h.events.push(MOUSEUP)) : g === MOUSEOUT ? h.fireOut = !0 : void 0, h;
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var a,
          b,
          c,
          d = this,
          e = d.getFromEnv('chart'),
          f = e.getChildren('canvas'),
          g = d.config.evtData,
          h = d.eventsList;

      for (e.config.enableMouseOutEvent && h.push(MOUSEOUT), d._removeListners(), g.chart = e, g.mouseTracker = d, b = 0; b < f.length; b++) {
        for (c in a = f[b], h) {
          a.addEventListener(h[c], d.handler);
        }
      }
    }
  }, {
    key: "_removeListners",
    value: function _removeListners() {
      var a,
          b,
          c,
          d = this,
          e = d.getFromEnv('chart'),
          f = e.getChildren('canvas'),
          g = d.eventsList;

      for (c = 0; c < f.length; c++) {
        for (b in a = f[c], g) {
          a.removeEventListener(g[b], d.handler);
        }
      }

      d._removeDocEvents();
    }
  }, {
    key: "_removeDocEvents",
    value: function _removeDocEvents() {
      this.eventOutput && this.eventOutput.unlisten(), this.eventOutput = UNDEF;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      this._removeListners(), _get(_getPrototypeOf(MouseTracker.prototype), "_dispose", this).call(this);
    }
  }]);

  return MouseTracker;
}(ComponentInterface);

export default MouseTracker;